import React from 'react'
import BreadcrumbThree from '../components/BreadcrumbThree'
import ShippingAndDelivery from '../components/ShippingAndDelivery'
import ShippingOne from '../components/ShippingOne'
import { Helmet } from 'react-helmet-async'

const ShippingAndDeliveyPage = () => {
  return (
    <>

      <Helmet>
        <title> Shipping and Delivery | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>
      {/* Breadcrumb */}
      <BreadcrumbThree title={"Shipping And Delivery"} />

      {/* Account */}
      <ShippingAndDelivery />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  )
}

export default ShippingAndDeliveyPage